import Component from './BadgeCategory.component';

export default Component;
